import { Extension } from "../../core/extension";
import { replaceMark, removeMark } from "../../commands/commands";
import { colors } from "./colors";
import { colorMarkSpec } from "./schema";
export class ColorExtension extends Extension {
    addMarks(marks) {
        return marks.append(colorMarkSpec());
    }
    addCommands(schema) {
        return {
            applyTextColor: (color) => {
                if (color === colors[0].value) {
                    return removeMark(schema.marks.color, { color });
                }
                return replaceMark(schema.marks.color, { color });
            },
        };
    }
}
